<template>
<div class="vm-dropdown" v-on-clickaway="hideDropdown" :class="[
    {'vm-dropdown-maxbo': maxbo},
    {'vm-dropdown-disabled': disabled},
    {'vm-dropdown-bold': bold},
    {'vm-dropdown-bold-options': boldOptions},
    {'vm-dropdown-valid': valid},
    {'vm-dropdown-invalid': invalid},
    {'vm-dropdown-error': error},
]">

    <div class="vm-dropdown-value" @click="handleValueClick">
        <label v-if="value">{{ value.display }}</label>
        <label v-if="!value">{{ placeholder }}</label>
    </div>

    <div v-if="expanded" class="vm-dropdown-list">

        <div class="vm-dropdown-item" v-for="(option, i) in options" :key="i" 
        :class="[{'vm-dropdown-item-warning': option.warning}]" @click="handleOptionClick(i)">
            <label>{{ option.display }}</label>
        </div>

    </div>

    <div class="vm-dropdown-icon" @click="handleValueClick">
        <svg v-if="expanded" height="26" version="1.1" width="26" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
            <path d="M 13 10.59375 L 21.765625 19.179688 C 22.15625 19.5625 22.78125 19.558594 23.171875 19.171875 L 24.707031 17.636719 C 25.097656 17.242188 25.097656 16.609375 24.703125 16.21875 L 13.707031 5.292969 C 13.511719 5.097656 13.257813 5 13 5 C 12.742188 5 12.488281 5.097656 12.292969 5.292969 L 1.296875 16.21875 C 0.902344 16.609375 0.902344 17.242188 1.292969 17.636719 L 2.828125 19.171875 C 3.21875 19.558594 3.84375 19.5625 4.234375 19.179688 Z"/>
        </svg>
        <svg v-if="!expanded" height="26" version="1.1" width="26" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
            <path d="M 13 15.40625 L 21.765625 6.820313 C 22.15625 6.4375 22.78125 6.441406 23.171875 6.828125 L 24.707031 8.363281 C 25.097656 8.757813 25.097656 9.390625 24.703125 9.78125 L 13.707031 20.707031 C 13.511719 20.902344 13.257813 21 13 21 C 12.742188 21 12.488281 20.902344 12.292969 20.707031 L 1.296875 9.78125 C 0.902344 9.390625 0.902344 8.757813 1.292969 8.363281 L 2.828125 6.828125 C 3.21875 6.441406 3.84375 6.4375 4.234375 6.820313 Z"/>
        </svg>
    </div>

</div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
name: 'vm-dropdown',
mixins: [clickaway],
props: {
    value: [Object],
    placeholder: {
        type: String,
        default: 'Ingenting valgt'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    maxbo: {
        type: Boolean,
        default: false
    },
    bold: {
        type: Boolean,
        default: false
    },
    boldOptions: {
        type: Boolean,
        default: false
    },
    options: {
        type: Array,
        default: () => { return [] }
    },
    valid: {
        type: Boolean,
        default: false
    },
    invalid: {
        type: Boolean,
        default: false
    },
    error: {
        type: Boolean,
        default: false
    }
},
data() {
    return {
        expanded: false
    }
},
methods: {
    handleValueClick() {
        this.expanded = !this.expanded;
    },
    handleOptionClick(index) {
        this.$emit('input', this.options[index]);
        this.expanded = false;
    },
    hideDropdown() {
        this.expanded = false;
    }
}
}
</script>
<style scoped>

.vm-dropdown {
    position: relative;
    float: left;
    width: 100%;
}

.vm-dropdown-value {
    width: 100%;
    height: 35px;
    padding-top: 7px;
    padding-left: 10px;
    border-radius: 3px;
    border: solid 1px lightgray;
    box-sizing: border-box;
    cursor: pointer;
}
.vm-dropdown-value label {
    cursor: pointer;
}
.vm-dropdown-value:hover {
    opacity: 0.8;
}

.vm-dropdown-maxbo .vm-dropdown-value {
    color: #004976;
    border-radius: 0px;
    border: solid 1px #004976;
    border-bottom: solid 2px #004976;
}

.vm-dropdown-disabled .vm-dropdown-value {
    background-color: #eaecef;
}

.vm-dropdown-valid .vm-dropdown-value {
    background-color: #C6EAD2;
}
.vm-dropdown-invalid .vm-dropdown-value {
    background-color: #F7CECB;
}
.vm-dropdown-error .vm-dropdown-value {
    background-color: #d15a68;
}

.vm-dropdown-icon {
    position: absolute;
    top: 4px; right: 4px;
    cursor: pointer;
}

.vm-dropdown-maxbo path {
    fill: #004976;
}

.vm-dropdown-list {
    position: absolute;
    width: 100%;
    min-height: 10px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    border: solid 1px lightgray;
    border-top: none;
    background-color: white;
    box-sizing: border-box;
    z-index: 2;
}

.vm-dropdown-bold-options .vm-dropdown-list {
    font-weight: bold;
}
.vm-dropdown-bold .vm-dropdown-value {
    font-weight: bold;
}

.vm-dropdown-maxbo .vm-dropdown-list {
    border-radius: 0px;
    border: solid 1px #004976;
    border-top: none;
}

.vm-dropdown-item {
    padding: 6px 10px;
    cursor: pointer;
}
.vm-dropdown-item label {
    cursor: pointer;
}
.vm-dropdown-item:hover {
    background-color: lightgray;
}

.vm-dropdown-item-warning label {
    color: red;
}

</style>
